import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 5l-8 4l8 4l8 -4l-8 -4","fill":"currentColor","key":"svg-0"}],["path",{"d":"M10 12l-6 3l8 4l8 -4l-6 -3","key":"svg-1"}]]

const IconStackForward = createReactComponent('outline', 'stack-forward', 'StackForward', __iconNode);

export default IconStackForward;